module.exports = __webpack_public_path__ + "static/media/happyBirthday.fa5cac4a.svg";